package com.ai.mitra.di


import com.ai.mitra.domain.use_cases.DeleteGroupWithMessageUseCase
import com.ai.mitra.domain.use_cases.DeleteMessageUseCase
import com.ai.mitra.domain.use_cases.GetAllGroupUserCase
import com.ai.mitra.domain.use_cases.GetAllMessageByGroupIdUserCase
import com.ai.mitra.domain.use_cases.GetContentUseCase
import com.ai.mitra.domain.use_cases.InsertGroupUseCase
import com.ai.mitra.domain.use_cases.InsertMessageUseCase
import com.ai.mitra.domain.use_cases.UpdatePendingUseCase
import org.koin.dsl.module

val useCaseModule = module {
    factory { GetAllGroupUserCase(get()) }
    factory { GetContentUseCase(get()) }
    factory { InsertGroupUseCase(get()) }
    factory { GetAllMessageByGroupIdUserCase(get()) }
    factory { InsertMessageUseCase(get()) }
    factory { UpdatePendingUseCase(get()) }
    factory { DeleteGroupWithMessageUseCase(get()) }
    factory { DeleteMessageUseCase(get()) }
}